import { render, staticRenderFns } from "./CommunityBusinessNewsCard.vue?vue&type=template&id=aa482e50&scoped=true&"
import script from "./CommunityBusinessNewsCard.vue?vue&type=script&lang=js&"
export * from "./CommunityBusinessNewsCard.vue?vue&type=script&lang=js&"
import style0 from "./CommunityBusinessNewsCard.vue?vue&type=style&index=0&id=aa482e50&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa482e50",
  null
  
)

export default component.exports